import { DEFAULT_ENQUIRY_MONTHS_AGO, STATUS_BADGE_COLOR } from '../../App/AppSettings.js';
import { getLangKey, getLicenceTypeNameTranslationKey } from '../../Content/DisplayComponents/DisplayUtils.js';
import { LANGUAGE_KEYS } from '../Constants/LanguageKeys.js';

// addMonth - START : Date parsers to prevent errors in the addMonth function
export function isLeapYear(year) {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)); 
}

export function getDaysInMonth(year, month) {
    return [31, (isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
}

export function addMonths(value) {
    var date = new Date();
    var n = date.getDate();
    date.setDate(1);
    date.setMonth(date.getMonth() + value);
    date.setDate(Math.min(n, getDaysInMonth(date.getFullYear(), date.getMonth())));
    return date;
}

export function getDateString(date) {
    if(date.type === Date.type){
        let dateString = new Intl.DateTimeFormat('en-GB', {
            year: 'numeric', 
            month: 'short', 
            day: '2-digit' })
            .format(date)
            .replace(/ /g,"-");
        return dateString;
    }
    else {
        return null;
    }
};
//addMonth - END
export const customMonthAgoString = getDateString(addMonths(-(DEFAULT_ENQUIRY_MONTHS_AGO)))
    
export const todayString = getDateString(new Date());

export function getBadgeColor(stateString) {
    var badgeColor = "normal"
    if((STATUS_BADGE_COLOR.success).indexOf(stateString) > -1) {
        badgeColor = "success"
    }
    else if((STATUS_BADGE_COLOR.warning).indexOf(stateString) > -1) {
        badgeColor = "warning"
    }
    else if((STATUS_BADGE_COLOR.danger).indexOf(stateString) > -1) {
        badgeColor = "danger"
    }

    return badgeColor;
}

export const arrayToSelectListOptions = (array, dropdownArray) => {
    if (Array.isArray(array)) {
        if (!(array === undefined || array.length === 0)) {
            array.forEach(element => {
                if (element !== null) {
                    dropdownArray.push({ label: element, value: element })
                }
            });
        }
    }
}

export const convertToFormData = (data) => {
    const formData = new FormData();

    for (let name in data) {
        // Else if the value is an object (Array is seen as an object too)
        if (typeof (data[name]) === 'object' && !Array.isArray(data[name])) {
            // Append object child items into formData
            appendChildToForm(formData, data[name], name);
        }

        // Otherwise, it is a normal input
        else {
            // Append key value to form
            formData.append(name, data[name]);
        }
    }
    return formData;
}

// Helper: Appends nested child objects to form recursively
const appendChildToForm = (formData, objItem, objItemPath) => {

    // If object item exists
    if (objItem) {

        // Get keys of object Items
        const objKeys = Object.keys(objItem);

        // For each key in object
        for (let i = 0; i < objKeys.length; i++) {

            // Get key via index
            let objKey = objKeys[i];

            // If VALUE of object Item is not an object OR its a DATE Object, end the recursion
            if ((objKey) && (typeof (objItem[objKey]) !== 'object' || objItem[objKey] instanceof Date)) {
                // Append key-pair value to form
                formData.append((objItemPath + "." + objKey), objItem[objKey]);
            }
            else if (objItem[objKey] && objItem[objKey].file instanceof File) {

                /*** FILE UPLOAD MODIFICATION ***/
                // Append fileName
                let fileNameStr = objItem[objKey].fileKey === undefined ? objItem[objKey].fileName : objItem[objKey].fileKey;

                // Append file with key as fileName
                formData.append(objItemPath, objItem[objKey].file, fileNameStr);

                // // Append key as fileKey, and value as description
                // formData.append(fileNameStr, name);

            }
            // Otherwise it is an object, continue recursion
            else {

                // Otherwise, append <OBJECT_ITEM_KEY><.><recursive_fn>
                appendChildToForm(formData, objItem[objKey], (objItemPath + "." + objKey));
            }
        }
    }
};
/**
 * start BLS form utils
 */
export const arrayToTranslatedLicenceNameSelectListOptions = (array, dropdownArray, t) => {
    if (Array.isArray(array)) {
        if (!(array === undefined || array.length === 0)) {
            array.forEach(element => {
                if (element !== null) {
                    const licenceTypeNameTranslationKey = getLicenceTypeNameTranslationKey(element.LicenceTypeName);
                    dropdownArray.push({ label: t(getLangKey(LANGUAGE_KEYS.BLS_SCOPE_LICENCETYPE_LICENCETYPENAME_KEY, licenceTypeNameTranslationKey, element.LicenceTypeId)), value: element.LicenceTypeId })
                }
            });
        }
    }
}

export const arrayToTranslatedDeliveryChannelSelectListOptions = (array, dropdownArray, t) => {
    if (Array.isArray(array)) {
        if (!(array === undefined || array.length === 0)) {
            array.forEach(element => {
                if (element !== null) {
                    dropdownArray.push({ label: t(getLangKey(LANGUAGE_KEYS.BLS_CODE_CORRESPONDENCETYPE_TITLE_KEY, element.DeliveryChannelCodeName)), value: element.DeliveryChannelId })
                }
            });
        }
    }
}

export const arrayToTranslatedLicenceStatusSelectListOptions = (array, dropdownArray, t) => {
    if (Array.isArray(array)) {
        if (!(array === undefined || array.length === 0)) {
            array.forEach(element => {
                if (element !== null) {
                    dropdownArray.push({ label: t(getLangKey(LANGUAGE_KEYS.BLS_CODE_LICENCESTATUS_TITLE_KEY, element.LicenceStatusCodeName)), value: element.LicenceStatus })
                }
            });
        }
    }
}
/**
 * end BLS form utils
 */